module.exports = __webpack_public_path__ + "img/1557614085788475397.c6c784ad.png";